/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Attempt,
  ErrorResponse,
  ValidationErrorResponse,
} from '../models';
import {
    AttemptFromJSON,
    AttemptToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models';

export interface AttemptsRetrieveRequest {
    id: number;
}

/**
 * 
 */
export class AttemptsApi extends runtime.BaseAPI {

    /**
     */
    async attemptsApplicantRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Attempt>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/attempts/applicant/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttemptFromJSON(jsonValue));
    }

    /**
     */
    async attemptsApplicantRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Attempt> {
        const response = await this.attemptsApplicantRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async attemptsCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Attempt>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/attempts/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttemptFromJSON(jsonValue));
    }

    /**
     */
    async attemptsCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Attempt> {
        const response = await this.attemptsCreateRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async attemptsListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Attempt>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/attempts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AttemptFromJSON));
    }

    /**
     */
    async attemptsList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Attempt>> {
        const response = await this.attemptsListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async attemptsRetrieveRaw(requestParameters: AttemptsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Attempt>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling attemptsRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/attempts/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttemptFromJSON(jsonValue));
    }

    /**
     */
    async attemptsRetrieve(requestParameters: AttemptsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Attempt> {
        const response = await this.attemptsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
